import { IdAmbito } from 'shell/constants/id-ambito';

export const getBaseUrl = (scope?: string, idCat?: string): string => {
  if (idCat) {
    return `/stato-civile/notifiche/ansc/${idCat}`;
  }

  if (!scope) {
    return '/notifiche/ansc';
  }

  switch (scope) {
    case IdAmbito.Iscrizioni:
      return '/iscrizioni/notifiche/ansc';
    case IdAmbito.Mutazioni:
      return '/mutazioni/notifiche/ansc';
    case IdAmbito.Cancellazioni:
      return '/cancellazioni/notifiche/ansc';
    default:
      return '';
  }
};
